import { getTopListKey } from 'live/components/index.shared';
import { getState } from 'live/redux/selectors/index.shared';
import get from 'lodash/get';
import { createSelector } from 'reselect';

// top list (top profits & dividends)

const topListTypeSelector = (_, props) => get(props, 'type');
const topListDateSelector = (_, { month, year }) =>
  getTopListKey({ month, year });

const getLiveTop = createSelector(getState, state => get(state, 'top'));

const getTopListState = createSelector(
  [getLiveTop, topListTypeSelector],
  (state, type) => get(state, type),
);

export const getTopListError = createSelector(
  [getTopListState, topListDateSelector],
  (state, date) => get(state.errors, date),
);

export const getTopListLoading = createSelector(
  [getTopListState, topListDateSelector],
  (state, date) => get(state.loading, date),
);

export const getTopList = createSelector(
  [getTopListState, topListDateSelector],
  (state, date) => get(state.resolved, date, []),
);
